import { CommonModule } from "@angular/common";
import { Component, Input, model, OnChanges, OnInit, signal, SimpleChanges } from "@angular/core";
import { FUNCTION_RESULT_STATUS, IObjectKey } from "@nova/common-interfaces";
import { IPaymentMethod } from "@rfm/shared-interfaces";
import { MenuItem, MessageService, ToastMessageOptions } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { MenuModule } from "primeng/menu";
import { BoolToTextPipe } from "../../../../../lib/pipes/index.mjs";
import { ThirdpartyStripePaymentMethodsComponent } from "../../../../billing/components/third-party/stripe/stripe-payment-methods/stripe-payment-methods.component";
import { CustomerService } from "../../../../shared/services/customers/customers.service.mjs";
import { ThirdPartyStripeService } from "../../../../shared/services/third-party/stripe/third-party-stripe.service";

@Component({
  selector: "app-payment-methods",
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, MenuModule, BoolToTextPipe],
  templateUrl: "./payment-methods.component.html",
  styleUrls: ["./payment-methods.component.scss"],
})
export class PaymentMethodsComponent implements OnInit, OnChanges {
  @Input()
  customer = signal<IObjectKey | undefined>(undefined);

  has_default_payment_method = model<boolean>(false);
  
  ref: DynamicDialogRef | undefined;
  payment_methods = signal<IPaymentMethod[] | undefined>(undefined);
  isLoading: boolean = false;

  activeRow: IPaymentMethod | undefined;

  items: MenuItem[] = [
    {
      label: "Make Default",
      icon: "pi pi-thumbtack",
      command: () => this.makeDefault(this.activeRow!.id),
    },
    {
      label: "Delete",
      icon: "pi pi-delete",
      command: () => this.delete(this.activeRow!.id),
    }
  ];

  stripeCustomerId: string | undefined;

  async makeDefault(payment_method_id: string)
  {
    await this.stripeService.setDefaultPaymentMethod(this.stripeCustomerId!, payment_method_id);
    await this.refreshData();
  }

  async delete(payment_method_id: string)
  {
    await this.stripeService.removePaymentMethod(payment_method_id);
    await this.refreshData();
  }

  addPaymentMethod() {
    this.ref = this.dialogService.open(ThirdpartyStripePaymentMethodsComponent, {
      data: {
        uid: this.customer()?.id,
      },
      width: "50vw",
      modal: true,
      focusOnShow: false,
      style: {
        "background-color": "#111827",
      },
      contentStyle: { overflow: "auto" },
      breakpoints: {
        "960px": "75vw",
        "640px": "90vw",
      },
    });

    this.ref.onClose.subscribe((data: any) => {
      this.refreshData();
      if (data) {
        this.messageService.add({
          severity: "success",
          text: "Payment was successful. Thank you!",
          life: 3000,
        } as ToastMessageOptions);
      }
    });
  }

  constructor(
    protected stripeService: ThirdPartyStripeService,
    private dialogService: DialogService,
    private messageService: MessageService,
    protected customerService: CustomerService
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.customer())
    {
      this.refreshData();
    }
  }

  ngOnInit() {
  }

  async refreshData() {
    this.isLoading = true;

    await this.customerService.get(this.customer()!.id).then(async (result) => {
      if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
        this.stripeCustomerId = result.data?.reference_keys.data.find(
          (x) => x.name === "stripe" && (x.referenceId && x.referenceId.length > 0)
        )?.referenceId;

        console.log("Stripe Customer ID", this.stripeCustomerId);

        await this.stripeService
          .getPaymentMethods(this.stripeCustomerId!)
          .then((result) => {
            console.log("methods", result);
            if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
              this.payment_methods.set(result.data);

              if (this.payment_methods()?.find(x => x.isDefault))
              {
                this.has_default_payment_method.set(true);
              }
              else
              {
                this.has_default_payment_method.set(false);
              }
            }
          });
      }
    })
    .finally(() => {
      this.isLoading=false;
    });    
  }

    menuClicked(rowData: IPaymentMethod) {
      this.activeRow = rowData;
    }
}
